module.exports = __webpack_public_path__ + "img/alipay.87ce9d5e.png";